<template>
  <div class="notify-card" @mouseenter="highlight = true" @mouseleave="highlight = false" :class="{ active: highlight }">
    <div class="w-100">
      <div class="notify-card--text">{{ announcement.name | translate | summary }}</div>
      <div class="notify-card--time">{{ announcement.dueDate | date }}</div>

      <div class="text-left" v-if="announcement.organization"><i class="bx bxs-school align middle mr-1"></i>{{ announcement.organization.name | summary }}</div>

      <div class="text-left text-main" v-else>{{ $t("common.public") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      highlight: false,
      icon: "icons/iconoir_apple-shortcuts.svg",
      iconActive: "icons/iconoir_apple-shortcuts-active.svg",
    };
  },
};
</script>

<style lang="scss" scoped>
.notify-card {
  display: flex;
  align-items: center;
  gap: 1.06rem;
  padding: 1.13rem;
  border-radius: 0.625rem;
  border: 1px solid #f1f2f3;
  background: #f8f8fb;
  font-family: "Roboto";
  font-size: 0.625rem;
  cursor: pointer;
  margin-bottom: 0.62rem;

  &.active,
  &:hover {
    background-color: #fff2ec;

    .notify-card--icon {
      color: #ff8f62;
    }
  }
}

.notify-card--icon {
}

.notify-card--text {
  color: #383a55;
  font-weight: 500;
}

.notify-card--time {
  color: #90979c;
  font-weight: 400;
}
.notify-card--organization {
  margin-left: auto;
}
</style>
